import { Drawer, List } from '@mui/material';
import '../styleDrawerConstruct.css';
import HighwayContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/HighwayContainerViewing';
import CantonContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/CantonContainerViewing';
import OpticFilterContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/OpticFilterContainerViewing';
import EquipmentFilterContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/EquipmentFilterContainerViewing';
import CommunicationsFilterContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/CommunicationsFilterContainerViewing';
import PoligonsFilterContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/PoligonsFilterContainerViewing';
import FeatureFilterContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/FeatureFilterContainerViewing';
import ContainerViewingConstruct from '../ContainerConstructionViewing/ContainerViewingConstruct';
import PoligonsFilterConstructionViewing from './ViewingContainer/PoligonsFilterConstructionViewing';

//#region STYLE
  const customStyles = {
    control: base => ({
      ...base,
      background: '#4b4b4b',
      borderRadius: '5px',
      fontSize: '16px',
      border: '1px solid #ffffff',
      marginBottom: '5px',
    }),
    singleValue: base => ({
      ...base,
      color: '#ffffff', 
    }),
    input: base => ({
      ...base,
      color: '#ffffff', 
    }),
    menu: base => ({
      ...base,
      background: '#4b4b4b',
      color: '#ececec', 
    }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
      color: isFocused ? '#000000' : '#ececec', 
    }),
  };
//#endregion 

const DrawerViewingConstruct = ({ openViewingDrawer, toggleViewingDrawer, loadingSummit,loadingCunton,
         toggleLayerVisibility,layersVisibility,
         canton, handleCantonChange,handleRegionChange,selectedRegionRef,regions,
          selectedAreaRef,area,handleClickCanton,layersVisibilityCommunications,
         toggleLayerVisibilityCommunications, handleLineCheckboxChange, showLines,
         city, handleCityChange, handleClickSummit, handleAreaChange,
         handleLine48CheckboxChange, showLines48,handleLine24CheckboxChange,showLines24,
         handleLine12CheckboxChange,showLines12,handleLine8CheckboxChange,showLines8,
         handleLine4CheckboxChange,showLines4,handleLine2CheckboxChange,showLines2,
         handleLine1CheckboxChange,showLines1, handleLine16CheckboxChange, showLines16,
         handleLine36CheckboxChange, showLines36,  handleLine64CheckboxChange, showLines64,
         handleLine72CheckboxChange, showLines72, handleLine96CheckboxChange, showLines96,handlePonLayerCheckboxChange,
         showPonLayer, handleLinesDenominationCheckboxChange,
         showLineDenomination, selectCityIsСhange,selectCantonIsСhange,
         selectedRegoin,selectedArea,showLinesTypeSolid, showLinesTypeDashed,
         handleLineTypeSolidCheckboxChange, handleLineTypeDashedCheckboxChange, handlePoligonCantonChange,
         showPolygonsCanton,handlePoligonAreaChange, showPolygonsArea,handleKtvLayerCheckboxChange, showKtvLayer,
         handleEtherLayerCheckboxChange,  showEtherLayer, handleLineTypeBasementCheckboxChange, showLinesTypeBasement,
         handleLineTypeFacadeCheckboxChange, showLinesTypeFacade, handleLineTypeLoftCheckboxChange, showLinesTypeLoft,
         handleHousesChange, showHouses, handleNumberPonBoxCheckboxChange, visibleNumberPonBox, handleHousesNoActivChange,
         showHousesActiv, handleHousesActivChange, showHousesNoActiv}) => {   
          
           
      
  return (
    <Drawer
      open={openViewingDrawer}
      onClose={toggleViewingDrawer(false)}
      PaperProps={{ className: 'drawerBackground hideScrollbar', style: { width: "260px" } }}
     
    >
      <div className="divTitleDrawerConstr">
        <p className='textTitleDrawer'>Фильтр</p>
      </div>

      <List>
        <div style={{paddingLeft:'5px', paddingRight: '5px'}}>
            {/* фильтр полигонов */}
            <PoligonsFilterConstructionViewing
              handlePoligonCantonChange={handlePoligonCantonChange}
              showPolygonsCanton={showPolygonsCanton}
              handlePoligonAreaChange={handlePoligonAreaChange}
              showPolygonsArea={showPolygonsArea}
              handleHousesChange={handleHousesChange}
              showHouses={showHouses}
              handleHousesNoActivChange={handleHousesNoActivChange}
              showHousesActiv={showHousesActiv}
              handleHousesActivChange={handleHousesActivChange}
              showHousesNoActiv={showHousesNoActiv}
            />
            <br/>
            {/* фильтр оптика */}
            <OpticFilterContainerViewing
              showLines={showLines}
              handleLineCheckboxChange={handleLineCheckboxChange}
              handleLine48CheckboxChange={handleLine48CheckboxChange}
              showLines48={showLines48}
              handleLine24CheckboxChange={handleLine24CheckboxChange}
              showLines24={showLines24}
              handleLine12CheckboxChange={handleLine12CheckboxChange}
              showLines12={showLines12}
              handleLine8CheckboxChange={handleLine8CheckboxChange}
              showLines8={showLines8}
              handleLine4CheckboxChange={handleLine4CheckboxChange}
              showLines4={showLines4}
              handleLine2CheckboxChange={handleLine2CheckboxChange}
              showLines2={showLines2}
              handleLine1CheckboxChange={handleLine1CheckboxChange}
              showLines1={showLines1}
              handleLine16CheckboxChange={handleLine16CheckboxChange}
              showLines16={showLines16}
              handleLine36CheckboxChange={handleLine36CheckboxChange}
              showLines36={showLines36}
              handleLine64CheckboxChange={handleLine64CheckboxChange}
              showLines64={showLines64}
              handleLine72CheckboxChange={handleLine72CheckboxChange}
              showLines72={showLines72}
              handleLine96CheckboxChange={handleLine96CheckboxChange}
              showLines96={showLines96}
              showLinesTypeSolid={showLinesTypeSolid}
              showLinesTypeDashed={showLinesTypeDashed}
              handleLineTypeSolidCheckboxChange={handleLineTypeSolidCheckboxChange}
              handleLineTypeDashedCheckboxChange={handleLineTypeDashedCheckboxChange}
              handleLinesDenominationCheckboxChange={handleLinesDenominationCheckboxChange}
              showLineDenomination={showLineDenomination}
              handleLineTypeBasementCheckboxChange={handleLineTypeBasementCheckboxChange}
              showLinesTypeBasement={showLinesTypeBasement}
              handleLineTypeFacadeCheckboxChange={handleLineTypeFacadeCheckboxChange}
              showLinesTypeFacade={showLinesTypeFacade}           
              handleLineTypeLoftCheckboxChange={handleLineTypeLoftCheckboxChange}
              showLinesTypeLoft={showLinesTypeLoft}
            />
          
            <br/>
            {/* фильтр коммуникации */}
            <CommunicationsFilterContainerViewing
              layersVisibilityCommunications={layersVisibilityCommunications}
              toggleLayerVisibilityCommunications={toggleLayerVisibilityCommunications}
              handleNumberPonBoxCheckboxChange={handleNumberPonBoxCheckboxChange}
              visibleNumberPonBox={visibleNumberPonBox}
            />
              
           </div> 
       
      </List>
    </Drawer>    
  );
};

export default DrawerViewingConstruct;